import React from 'react';
import PageHeader from 'components/PageHeader';
import Footer from 'components/PageFooter';
import { Link } from 'react-router-dom';

const PrivacyPolicy: React.FC = () => {
  return (
    <div className="min-h-screen flex flex-col bg-gray-50 dark:bg-gray-900">
      <PageHeader />
      <div className="flex-1 w-full max-w-4xl mx-auto py-8 px-4 sm:px-6 lg:px-8">
        <h2 className="text-5xl font-bold text-gray-900 dark:text-white mb-2 text-center">
          Privacy Policy
        </h2>
        <p className="text-gray-600 dark:text-gray-400 mt-10 ml-2">
          Region EU not activated for privacy-statement.
        </p>

        <h3 className="text-2xl font-bold text-gray-900 dark:text-white mb-2 mt-5">
          What do we do with your information?
        </h3>
        <p className="text-gray-600 dark:text-gray-400 mt-4 ml-2">
          When you purchase on our website, as part of the buying and selling process, we collect the personal information you give us such as your name, address, and email address.
        </p>
        <p className="text-gray-600 dark:text-gray-400 mt-4 ml-2">
          <b>Email marketing:</b> With your permission, we may send you emails about our store, new products, and other updates.
        </p>

        <h3 className="text-2xl font-bold text-gray-900 dark:text-white mb-2 mt-5">
          Consent
        </h3>
        <p className="text-gray-600 dark:text-gray-400 mt-4 ml-2">
          <i>How do you get my consent?</i> - To obtain your consent, we assume that you have given it when you provide personal information to us for the purpose of completing a transaction, verifying a credit card, placing an order, arranging delivery, or returning a purchase. If we need your personal information for a secondary purpose, such as marketing, we will either ask for your explicit consent or provide you with a way to decline.
        </p>
        <p className="text-gray-600 dark:text-gray-400 mt-4 ml-2">
          <i>How do I withdraw my consent?</i> - If you change your mind after opting in, you can withdraw your consent at any time by contacting us.
        </p>

        <h3 className="text-2xl font-bold text-gray-900 dark:text-white mb-2 mt-5">
          Disclosure
        </h3>
        <p className="text-gray-600 dark:text-gray-400 mt-4 ml-2">
          We may disclose your personal information only if we are required to do so by law or if you violate our <Link to="/terms-of-service"><b>Terms of Service.</b></Link>
        </p>

        <h3 className="text-2xl font-bold text-gray-900 dark:text-white mb-2 mt-5">
          Third-party services
        </h3>
        <p className="text-gray-600 dark:text-gray-400 mt-4 ml-2">
          The third-party providers we use will collect, use, and disclose your information to the extent required to perform their services. However, payment gateways and other payment processors have their privacy policies for purchase-related transactions. You should read their policies to understand how your personal information will be handled, especially if they are located in a different jurisdiction. Once you leave our site or are redirected to a third-party site or application, you are no longer governed by our Privacy Policy or Terms and Conditions.
        </p>

        <h3 className="text-2xl font-bold text-gray-900 dark:text-white mb-2 mt-5">
          Links
        </h3>
        <p className="text-gray-600 dark:text-gray-400 mt-4 ml-2">
          When you click on links on our store, they may redirect you to other sites. We are not responsible for the privacy practices of other sites and encourage you to read their privacy statements.
        </p>

        <h3 className="text-2xl font-bold text-gray-900 dark:text-white mb-2 mt-5">
          Security
        </h3>
        <p className="text-gray-600 dark:text-gray-400 mt-4 ml-2">
          We take reasonable precautions and follow industry best practices to protect your personal information from loss, misuse, unauthorized access, disclosure, alteration, or destruction. If you provide us with your credit card information, we encrypt it using secure socket layer technology (SSL) to ensure its safety.
        </p>

        <h3 className="text-2xl font-bold text-gray-900 dark:text-white mb-2 mt-5">
          Cookies
        </h3>
        <p className="text-gray-600 dark:text-gray-400 mt-4 ml-2">
          We use various cookies on our website. If you are unfamiliar with cookies, or how to manage or remove them, we suggest you go to http://www.aboutcookies.org for detailed guidance. The list below outlines the cookies we use on our website and their purposes. We currently operate on an “implied consent” policy, assuming you are comfortable with this usage. However, if you are not, you may choose not to use our site, delete the cookies after visiting our site, or use your browser’s anonymous usage setting (e.g., “Incognito” in Chrome, “InPrivate” for Internet Explorer, “Private Browsing” in Firefox and Safari, etc.).
        </p>

        <h3 className="text-2xl font-bold text-gray-900 dark:text-white mb-2 mt-5">
          Age of consent
        </h3>
        <p className="text-gray-600 dark:text-gray-400 mt-4 ml-2">
          By using this site, you confirm that you have reached the age of majority in your state or province of residence, or that you have attained the age of majority in your state or province of residence and have given us consent to allow your minor dependents to use this site.
        </p>

        <h3 className="text-2xl font-bold text-gray-900 dark:text-white mb-2 mt-5">
          Changes to this privacy policy
        </h3>
        <p className="text-gray-600 dark:text-gray-400 mt-4 ml-2">
          We reserve the right to modify this privacy policy at any time, so please review it frequently. Changes and clarifications will take effect immediately upon their posting on the website. If we make material changes to this policy, we will notify you here that it has been updated, so that you are aware of what information we collect, how we use it, and under what circumstances, if any, we use and/or disclose it.
        </p>

        <h4 className="text-l font-bold text-gray-500 dark:text-white mb-2 mt-7 pt-5 border-t">
          Questions & contact information
        </h4>
        <p className="text-gray-600 dark:text-gray-400 mt-4">
          If you would like to: access, correct, amend, or delete any personal information we have about you, register a complaint, or simply want more information contact our Privacy Compliance Officer at <b>office@sigedon.com</b>.
        </p>
      </div>
      <Footer />
    </div>
  )
}

export default PrivacyPolicy;